import { InMemoryCache } from "@apollo/client";
import dataIdFromObject from "../../internal/shared/apollo/dataIdFromObject";
const createCache = (schemas)=>{
    const possibleTypes = {};
    const anonymousTypes = [];
    for(const schemaKey in schemas){
        if (schemas.hasOwnProperty(schemaKey)) {
            const schema = schemas[schemaKey];
            if (schema === null || schema === void 0 ? void 0 : schema.possibleTypes) {
                for(const key in schema.possibleTypes){
                    if (schema.possibleTypes.hasOwnProperty(key)) {
                        possibleTypes[key] = schema.possibleTypes[key];
                    }
                }
            }
            if (schema === null || schema === void 0 ? void 0 : schema.anonymousTypes) {
                for (const anonymousType of schema.anonymousTypes){
                    anonymousTypes.push(anonymousType);
                }
            }
        }
    }
    return new InMemoryCache({
        possibleTypes,
        dataIdFromObject,
        typePolicies: Object.fromEntries(anonymousTypes.map((type)=>[
                type,
                {
                    merge: true
                }
            ]))
    });
};
export default createCache;

//# sourceMappingURL=createCache.js.map